import { gatewayInstance } from "../../axiosInstance";
import { errorMessageToast } from "../../helper";

export const searchChargeConfirmation = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "financeservice/job-charge-confirmation/search",
      data,
    );
    return response.data !== null ? response.data : [];
  } catch (e) {
    errorMessageToast(e);
  }
};

export const searchBatchChargeConfirmation = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "financeservice/job-charge-confirmation/batch/search",
      data,
    );
    return response.data !== null ? response.data : [];
  } catch (e) {
    console.error(e);
  }
};

export const deleteChargeApprovals = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "financeservice/job-charge-confirmation/delete",
      data,
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getChargesByChhIdAndChargeCategory = async (
  chhId,
  chargeCategory,
) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/job-charge-creation/by-id-and-charge-category/${chhId}/${chargeCategory}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getChargesByChhIdAndChargeCategoryForApproval = async (
  chhId,
  chargeCategory,
) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/job-charge-creation/by-id-and-charge-category/approval/${chhId}/${chargeCategory}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getChargesByChhIdAndChargeCategoryNotGenerated = async (
  chhId,
  chargeCategory,
) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/job-charge-creation/by-id-and-charge-category-non-generated/${chhId}/${chargeCategory}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const confirmCharges = async (data) => {
  const response = await gatewayInstance.post(
    "/financeservice/job-charge-confirmation",
    data,
  );
  return response.data;
};

export const updateChargeApproval = async (data) => {
  const response = await gatewayInstance.put(
    "/financeservice/job-charge-confirmation",
    data,
  );
  return response.data;
};

export const getChargeApproveHeader = async (id) => {
  const response = await gatewayInstance.get(
    `/financeservice/job-charge-confirmation/${id}`,
  );
  return response.data;
};

export const taxCalculate = async (data) => {
  const response = await gatewayInstance.post(
    "/financeservice/ev-inv-generator/tax-calculate",
    data,
  );
  return response.data;
};

export const saveJobEvInv = async (data) => {
  const response = await gatewayInstance.post(
    "/financeservice/ev-inv-generator",
    data,
  );
  return response.data;
};

export const searchEvInv = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "financeservice/ev-inv-generator/search",
      data,
    );
    return response.data !== null ? response.data : [];
  } catch (e) {
    console.error(e);
  }
};

export const chargeById = async (chpCharge) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/pattern/distinct/${chpCharge}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const saveEvInvInAdHoc = async (data, evInv) => {
  const response = await gatewayInstance.post(
    `/financeservice/ev-inv-generator/save-ev-inv-in-ad-hoc/${evInv}`,
    data,
  );
  return response;
};

export const approveEvInvInAdHoc = async (data) => {
  const response = await gatewayInstance.post(
    "/financeservice/ev-inv-generator/approve-ev-inv-in-ad-hoc",
    data,
  );
  return response;
};
